import { getRequest, postRequest } from 'utils/httpServices';

class referralsAPI {
  static list = (queryData = {}, config = {}) => {
    return postRequest(`v2/dashboard/referred/list`, queryData, config).catch((error) => ({
      success: false,
      data: (error.response && error.response.data) || {},
      status: (error.response && error.response.status) || 400
    }));
  };

  static gtvData = (queryData = {}, config = {}) => {
    return postRequest(`v1/referral-gtv`, queryData, config).catch((error) => ({
      success: false,
      data: (error.response && error.response.data) || {},
      status: (error.response && error.response.status) || 400
    }));
  };

  static summary = (queryData = {}, config = {}) => {
    return getRequest(`v2/dashboard/referred/partner-summary`, queryData, config).catch(
      (error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400
      })
    );
  };
}

export default referralsAPI;
